export default __webpack_public_path__ + "static/Electrical_Outlet-76ce0913de7ec01bccd88c759d638794.png";